import { getCompatConfig } from '../compat.js';

var UploadStatus = /* @__PURE__ */ function(UploadStatus2) {
  UploadStatus2[UploadStatus2["IN_PROGRESS"] = 0] = "IN_PROGRESS";
  UploadStatus2[UploadStatus2["COMPLETED"] = 1] = "COMPLETED";
  UploadStatus2[UploadStatus2["ERROR"] = 2] = "ERROR";
  return UploadStatus2;
}({});
const getCompatFile = () => {
  return getCompatConfig().FILE;
};

export { UploadStatus, getCompatFile };
//# sourceMappingURL=file.js.map
